import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { IApiResponse } from '@app/api/interfaces/common/api-response.interface';
import { IListFilter } from '@app/api/interfaces/common/list-filter';
import { IPaginationMeta, IPaginationRequest } from '@app/api/interfaces/common/pagination-meta.interface';
import { prepareParamsForRequest } from '@app/core/methods/http-params';
import { SplitRequestService } from '@app/core/services/split-request-by-limit/split-request.service';
import { ILoggerMeasurement } from '@app/api/interfaces/logger-measurement.interface';
import { ILoggerMeasurementSoundSignal } from '@app/api/interfaces/logger-measurement-sound-signal.interface';

@Injectable({
  providedIn: 'root',
})
export class LoggerMeasurementsApiService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly splitRequestService: SplitRequestService
  ) {}

  public getByProjectId(
    projectId: string,
    filter: IListFilter = {},
    pagination: Partial<IPaginationRequest> = {
      limit: 1000,
    },
    all = true
  ): Observable<IApiResponse<ILoggerMeasurement[], IPaginationMeta>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements`;

    const filterForParams = prepareParamsForRequest(filter);

    const params = new HttpParams({
      fromObject: {
        ...(filterForParams || {}),
        ...(pagination || {}),
      },
    });

    const options = {
      params,
      withCredentials: true,
    };

    if (all) {
      return this.splitRequestService.getInParallel<ILoggerMeasurement, IPaginationMeta>(url, options);
    } else {
      return this.httpClient.get<IApiResponse<ILoggerMeasurement[], IPaginationMeta>>(url, options);
    }
  }

  public getOne(projectId: string, loggerMeasurementId: string): Observable<IApiResponse<ILoggerMeasurement, object>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${loggerMeasurementId}`;

    return this.httpClient.get<IApiResponse<ILoggerMeasurement, object>>(url, {
      withCredentials: true,
    });
  }

  public getSoundSignals(
    projectId: string,
    loggerMeasurementId: string,
    pagination: Partial<IPaginationRequest> = {
      limit: 1000,
    },
    all = true
  ): Observable<IApiResponse<ILoggerMeasurementSoundSignal[], IPaginationMeta>> {
    const url = `${environment.apiBaseUrl}/v1/projects/${projectId}/logger-measurements/${loggerMeasurementId}/sound-signals`;

    const params = new HttpParams({
      fromObject: {
        ...(pagination || {}),
      },
    });

    const options = {
      params,
      withCredentials: true,
    };

    if (all) {
      return this.splitRequestService.getInParallel<ILoggerMeasurementSoundSignal, IPaginationMeta>(url, options);
    } else {
      return this.httpClient.get<IApiResponse<ILoggerMeasurementSoundSignal[], IPaginationMeta>>(url, options);
    }
  }
}
